import React, { useState } from "react";
import {
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const FormControlSelect = ({
    formControlData: {
        value,
        handleChange,
        dataList,
        checked,
        handleCheckboxChange,
        selectedData,
        disabled = false,
    },
    placeholder,
}) => {

    const [open, setOpen] = useState(false);

    return (
        <FormControl sx={{ m: 1, minWidth: 120 }}>
            <Select
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                value={value}
                onChange={handleChange}
                displayEmpty
                disabled={disabled}
                inputProps={{ "aria-label": "Without label" }}
                IconComponent={KeyboardArrowDownIcon}
                className="map_dropdown"
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    PaperProps: {
                        classes: {
                            root: "custom-paper-class",
                        },
                    },
                }}
            >
                <MenuItem className="hidedata" value="">
                    <em>{placeholder}</em>
                    {selectedData?.length === 0 ? (
                        <p>Select</p>
                    ) : (
                        <p>{selectedData?.length} Selected</p>
                    )}
                </MenuItem>


                <div className="">
                    <div>
                        {Array.isArray(dataList) && dataList.length > 0 &&
                            dataList.map((item, index) => (
                                <React.Fragment key={index}>
                                    <div className={checked?.includes(item) ? "AI-leade-checkbox-and-data-list_2" : "AI-leade-checkbox-and-data-list"}>
                                        <div className="checkbox-select-data">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={checked?.includes(item)}
                                                        value={item}
                                                        onChange={(event) =>
                                                            handleCheckboxChange(event, item)
                                                        }
                                                        className="checkbox-green"
                                                        color="success"
                                                    />
                                                }

                                                label={
                                                    <MenuItem key={index} value={item} className={value === item ? "selectedfiltermap" : ""} style={{ padding: '0px' }}>
                                                        {item
                                                            .split("_")
                                                            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                            .join(" ")}                                                    </MenuItem>
                                                }
                                            />
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}
                    </div>
                </div>
            </Select>
        </FormControl>
    );
};

export default FormControlSelect;